// src/hooks/useUpdateSinisterStatus.ts
import { useState } from "react";
import { SinisterService } from "../../../shared/services/api/sinister/SinisterService";
import { useToast } from "../../../shared/hooks";
import { ToastContent } from "../../../shared/components";

export function useUpdateSinisterStatus(refetch: () => void, onClose: () => void) {
	const [isLoading, setIsLoading] = useState(false);
	const toastHandler = useToast();

	const update = async (id: string, data: { status: string }) => {
		setIsLoading(true);
		try {
			await SinisterService.updateStatusSinister(id, data);
			await refetch();
			toastHandler.present({
				type: "success",
				position: "top-right",
				messageOrContent: <ToastContent title="Sucesso" content="Status do sinistro atualizado com sucesso" />,
			});
			onClose();
		} catch {
			toastHandler.present({
				type: "error",
				messageOrContent: "Erro ao atualizar status do sinistro",
			});
		} finally {
			setIsLoading(false);
		}
	};

	return { update, isLoading };
}
